import { makeStyles } from "@material-ui/core/styles";
import { RemittanceStatusEnum } from "@saleor/types/globalTypes";
import classNames from "classnames";
import React from "react";

const useStyles = makeStyles(
  () => ({
    remittanceStatusLabel: {
      fontWeight: 600,
      marginLeft: "13px",
      overflow: "hidden",
      paddingRight: "11px",
      textOverflow: "ellipsis"
    },

    statusDefaultLabel: {
      backgroundColor: "#FEF7B4"
    },
    statusForConfirmation: {
      border: "solid",
      color: "#ffa600"
    },
    statusHolder: {
      display: "flex",
      marginLeft: "10px"
    },
    statusRemitted: {
      backgroundColor: "#A4EA9A"
    },
    statusToRemit: {
      backgroundColor: "#FEF7B4"
    },

    statusWrapper: {
      borderRadius: "25px",
      display: "inline",
      margin: "2px",
      paddingBottom: "5px",
      paddingTop: "5px",
      position: "relative",
      whiteSpace: "nowrap"
    }
  }),
  { name: "RemittanceRunnerRemittanceStatus" }
);

export interface RemittanceRunnerRemittanceStatusProps {
  status: RemittanceStatusEnum;
}

const RemittanceRunnerRemittanceStatus: React.FC<RemittanceRunnerRemittanceStatusProps> = props => {
  const { status } = props;
  const classes = useStyles(props);

  let newLabel = "";
  switch (status) {
    case RemittanceStatusEnum.TO_REMIT:
      newLabel = "To Remit";
      break;
    case RemittanceStatusEnum.FOR_BANK_CONFIRMATION:
      newLabel = "For Confirmation";
      break;
    case RemittanceStatusEnum.REMITTED:
      newLabel = "Remitted";
      break;
    default:
      newLabel = status;
      break;
  }

  const getStatusLabel = () => {
    switch (status) {
      case RemittanceStatusEnum.TO_REMIT:
        return (
          <div
            className={classNames(classes.statusToRemit, classes.statusWrapper)}
          >
            <span className={classes.remittanceStatusLabel}>{newLabel}</span>
          </div>
        );
      case RemittanceStatusEnum.FOR_BANK_CONFIRMATION:
        return (
          <div
            className={classNames(
              classes.statusForConfirmation,
              classes.statusWrapper
            )}
          >
            <span className={classes.remittanceStatusLabel}>{newLabel}</span>
          </div>
        );
      case RemittanceStatusEnum.REMITTED:
        return (
          <div
            className={classNames(
              classes.statusRemitted,
              classes.statusWrapper
            )}
          >
            <span className={classes.remittanceStatusLabel}>{newLabel}</span>
          </div>
        );
      default:
        return (
          <div
            className={classNames(
              classes.statusDefaultLabel,
              classes.statusWrapper
            )}
          >
            <span className={classes.remittanceStatusLabel}>{newLabel}</span>
          </div>
        );
    }
  };

  return getStatusLabel();
};

export default RemittanceRunnerRemittanceStatus;
